import React from "react";
import { Youtube, Facebook, Instagram, Linkedin } from "lucide-react";

const iconStyle = {
  color: "white",
  width: 28,
  height: 28,
};

const SocialSidebar = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        right: 0,
        transform: "translateY(-50%)",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        zIndex: 1000,
        backgroundColor: "#3f6c68",
        padding: "8px",
        borderTopLeftRadius: "10px",
        borderBottomLeftRadius: "10px",
      }}
    >
      <a
        href="https://www.youtube.com/@TaxwithoutTears"
        target="_blank"
        rel="noreferrer"
      >
        <Youtube style={iconStyle} />
      </a>

      <a
        href="https://www.facebook.com/vagarwal123"
        target="_blank"
        rel="noreferrer"
      >
        <Facebook style={iconStyle} />
      </a>

      <a
        href="https://www.instagram.com/cavijenderaggarwal"
        target="_blank"
        rel="noreferrer"
      >
        <Instagram style={iconStyle} />
      </a>

      <a
        href="https://www.linkedin.com/in/ca-vijender-aggarwal-01836733a/"
        target="_blank"
        rel="noreferrer"
      >
        <Linkedin style={iconStyle} />
      </a>
    </div>
  );
};

export default SocialSidebar;
